import { Injectable } from '@angular/core';

import { EnvError } from '../business/env-error';
import { NumberUtils } from '../utils/number.utils';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class RandomUrlService {
    private memoizedKeys = new Map();

    public constructor(private environmentService: EnvironmentService) {}

    /**
     * Return object where url is input url with round-robin placeholder replaced by base url from env.json and partner concatenated with round-robin key
     */
    public getUrlAndPartner(url: string, partner: string): { url: string; partner: string } {
        let processedUrl = url;
        if (processedUrl.startsWith('round-robin:')) {
            const matches = /^round-robin:([a-zA-Z0-9_-]+)(.*)/.exec(processedUrl);
            if (matches[1]) {
                const urlAndBcoKey = this.getRoundRobinUrlAndBcoKey(matches[1]);
                processedUrl = urlAndBcoKey.url + (matches[2] || '');
                if (urlAndBcoKey.bcoKey) {
                    partner = `${partner}-${urlAndBcoKey.bcoKey}`;
                }
            }
        }
        return { url: processedUrl, partner };
    }

    private getRoundRobinUrlAndBcoKey(key: string): { url: string; bcoKey: string } {
        const env = this.environmentService.instant();
        let result;

        if (this.memoizedKeys.has(key)) {
            return this.memoizedKeys.get(key);
        } else if (
            env.ROUND_ROBIN?.[key]?.URLS &&
            Object.keys(env.ROUND_ROBIN[key].URLS).length > 0 &&
            NumberUtils.randInt() < env.ROUND_ROBIN[key].LOAD
        ) {
            const urls = env.ROUND_ROBIN[key].URLS;
            const urlKeys = Object.keys(urls);
            const bcoKey = urlKeys[NumberUtils.randInt(urlKeys.length)];
            result = { url: urls[bcoKey], bcoKey };
        } else if (env.ROUND_ROBIN?.[key]?.DEFAULT) {
            result = { url: env.ROUND_ROBIN[key].DEFAULT, bcoKey: '' };
        } else {
            throw new EnvError(`Default url is missing for roundRobin key ${key}`);
        }

        this.memoizedKeys.set(key, result);

        return result;
    }
}
